import { render, staticRenderFns } from "./CartDeliveryDetails.vue?vue&type=template&id=0bbb8478"
import script from "./CartDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./CartDeliveryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports